export * from './scd-extern-dialog.component';
